import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "./assets/sass/main.scss";
import "./ml";

import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import Multiselect from "vue-multiselect";
import VueApexCharts from "vue-apexcharts";
import axiosConfigs from "./HTTP";
import store from "./state/store";
import router from "./router/index";
import Vuelidate from "vuelidate";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import { utils } from "./utils.js";
import bPagination from "bootstrap-vue";
import VueCustomTooltip from "@adamdehaven/vue-custom-tooltip";
import VuePageTransition from "vue-page-transition";
import VuePhoneNumberInput from "vue-phone-number-input";
import HeaderComp from "./components/header";
import Impact from "./components/impact";
import ProgressImpact from "./components/progressImpact";
import Spinner from "./components/spinner";
import CardCreatProgram from "./components/cardCreatProgram";
import WarningMessage from "./components/warningMessage";
import DangerMessage from "./components/dangerMessage";
import ProgramEfficiency from "./components/programEfficiency";

Vue.use(VuePageTransition);
Vue.use(VueApexCharts);

let token = localStorage.getItem("token");
axiosConfigs(token);

Vue.prototype.$utils = utils;

Vue.use(bPagination);
Vue.use(VuePhoneNumberInput);
Vue.use(CardCreatProgram);
Vue.use(HeaderComp);
Vue.use(Impact);
Vue.use(ProgressImpact);
Vue.use(Spinner);
Vue.use(DangerMessage);
Vue.use(WarningMessage);
Vue.use(ProgramEfficiency);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(money, {
    decimal: ",",
    thousands: ".",
    prefix: "      ",
    suffix: "",
    precision: 2,
    masked: false,
});
Vue.use(VueCustomTooltip);

Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.component("CardCreatProgram", CardCreatProgram);
Vue.component("multiselect", Multiselect);
Vue.component("HeaderComp", HeaderComp);
Vue.component("Impact", Impact);
Vue.component("ProgressImpact", ProgressImpact);
Vue.component("Spinner", Spinner);
Vue.component("DangerMessage", DangerMessage);
Vue.component("WarningMessage", WarningMessage);
Vue.component("ProgramEfficiency", ProgramEfficiency);
Vue.component('apexchart', VueApexCharts);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");